// Tees are named by colour almost everywhere in golf, so a tee's name is also
// its visual identity. Shared by the tee-selection modal, the group-assignment
// chips and the mixed-tee scoring sections, so one tee looks the same wherever
// it appears.

const TEE_COLORS = {
  white: '#ffffff', yellow: '#f5c542', red: '#e74c3c', blue: '#3498db',
  black: '#2c3e50', green: '#27ae60', gold: '#f5a623', orange: '#e67e22',
  purple: '#8e44ad', silver: '#95a5a6', pink: '#e91e8f', brown: '#8B4513',
};

// The hex for a tee name, or null when the name carries no colour word (e.g.
// "Championship", "Forward") — callers fall back to a neutral swatch.
export const getTeeColor = (name) => {
  const key = name?.toLowerCase().trim();
  if (!key) return null;
  // Exact match first, then check if name contains a colour word
  if (TEE_COLORS[key]) return TEE_COLORS[key];
  for (const [color, hex] of Object.entries(TEE_COLORS)) {
    if (key.includes(color)) return hex;
  }
  return null;
};

// A white or unrecognised tee needs a visible outline or its dot disappears
// against the card.
export const teeNeedsOutline = (name) => {
  const color = getTeeColor(name);
  return !color || name?.toLowerCase().includes('white');
};
